<template>
  <div class="open-screen-loading skeleton-el">
    <div class="img-wrap">
        <img src="/open_screen.gif" alt="">
    </div>
    <p>请稍等...</p>
    <div class="logo">
        <img src="/logo.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
};
</script>
<style lang="scss" scoped>
.open-screen-loading {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img-wrap {
    width: 33.3%;
    margin: 40% auto 0;
  }
  .logo {
    width: 50%;
    margin: 50% auto 0;
  }
  img {
    width: 100%;
    height: auto
  }
  p {
    font-weight: 700;
    padding-top: 5.5%;
    text-align: center;
    font-size: 32px;
  }
}

</style>
